// export const linkServer = process.env.REACT_APP_SERVER_LINK;
export const dwvLink = process.env.REACT_APP_DWV_LINK;
